import { GroupType, getGroupType } from '../types/GroupType'

const STORAGE_KEY = 'AlertPaneSelectedGrouping'

const setSelectedGrouping = (grouping: GroupType): void => {
  localStorage.setItem(STORAGE_KEY, grouping.toString())
}

const getSelectedGrouping = (): GroupType | null => {
  const groupType: string | null = localStorage.getItem(STORAGE_KEY)
  return groupType ? getGroupType(groupType) : null
}

export const alertGroupingLocalStorage = {
  setSelectedGrouping,
  getSelectedGrouping,
}
